import SplitWithImageFullWidth from './SplitWithImageFullWidth'
export default SplitWithImageFullWidth
